module.exports = __webpack_public_path__ + "img/pos.37bbd46b.jpg";